import { OfferStatus } from '@core/offers-types';
import { InviteMemberPayload, TellentClientDialogResult } from '@core/tellent-types';

export type HiringResource = {
  id: string;
  createdAt?: string;
  department?: string;
  guid: string;
  kind?: string;
  locations?: string[];
  recruitmentId: string;
  status?: OfferStatus;
  title: string;
  updated_at?: string;
};

export enum HiringResourceKind {
  Job = 'job',
  TalentPool = 'talent_pool',
}

export type AssignMembersToJobsDialogData = {
  recruiteeRoleId: string;
  kiwiRoleId: string;
  shouldOpenSecondStep: boolean;
  payload: InviteMemberPayload;
};

export type AssignMembersToJobsDialogResult = TellentClientDialogResult<any>;

export type AssignMembersToJobsExtraPayload = {
  hiringResources: {
    jobs: string[];
    talentPools: string[];
  };
};

export type HiringResourceEntity = HiringResource;
export type HiringResourceScope = 'jobs' | 'talentPools';

export type HiringResourcesFetchResponse = { data: HiringResource[] };
